<template>
  <div class="filter-box statuses-checkbox">
    <div class="row justify-between">
      <span class="filter-box-heading">Status</span>
      <i class="las la-2x la-times-circle clear-icon" @click="resetSelected()">
        <q-tooltip>
          Filter leegmaken
        </q-tooltip>
      </i>
    </div>

    <q-checkbox dense v-model="open" label="Open" class="status-checkbox" />
    <q-checkbox
      dense
      v-model="forthcoming"
      label="Aangekondigd"
      class="status-checkbox"
    />
    <q-checkbox
      dense
      v-model="closed"
      label="Gesloten"
      class="status-checkbox"
    />
    <q-checkbox
      dense
      v-model="discontinued"
      v-if="showDiscontinuedCheckbox"
      label="Gestopt"
      class="status-checkbox"
    />
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import store from '../../store/index';
import SchemeUtils from '../../utils/schemes';
export default {
  setup() {
    onMounted(() => {
      store.commit('advancedSearch/createStatusesString');
    });

    const open = computed({
      get: () => store.state.advancedSearch.showOpen,
      set: async (value) => {
        store.commit('advancedSearch/updateShowOpen', value);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      },
    });
    const forthcoming = computed({
      get: () => store.state.advancedSearch.showForthcoming,
      set: async (value) => {
        store.commit('advancedSearch/updateShowForthcoming', value);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      },
    });
    const closed = computed({
      get: () => store.state.advancedSearch.showClosed,
      set: async (value) => {
        store.commit('advancedSearch/updateShowClosed', value);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      },
    });
    const discontinued = computed({
      get: () => store.state.advancedSearch.showDiscontinued,
      set: async (value) => {
        store.commit('advancedSearch/updateShowDiscontinued', value);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      },
    });

    const resetSelected = () => {
      store.commit('advancedSearch/updateShowOpen', false);
      store.commit('advancedSearch/updateShowClosed', false);
      store.commit('advancedSearch/updateShowForthcoming', false);
      store.commit('advancedSearch/updateShowDiscontinued', false);
      if (!isSearchPaused.value) SchemeUtils.searchSchemes();
    };
    const showDiscontinuedCheckbox = store.state.auth.env !== 20;
    const isSearchPaused = computed({
      get: () => store.state.advancedSearch.applySavedSearchPause,
    });
    return {
      isSearchPaused,
      resetSelected,
      group: ref([]),
      open,
      forthcoming,
      closed,
      discontinued,
      showDiscontinuedCheckbox
    };
  },
};
</script>

<style></style>
